import router from '../router'
import store from '../store'
import NProgress from 'nprogress' // progress bar
import { isMobile, isMobileUrl } from '@/utils/tool';

// NProgress.configure({ showSpinner: false })// NProgress configuration

const whiteList = ['/login'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  NProgress.start();

  const toHref = to.fullPath;

  if (isMobile()) {
    location.href= '/mobile/index';
  } else {
    next()
  }

  NProgress.done()
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/utils/permission.js